<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <template v-slot:message>
      <p v-html="formatChatMessage"></p>
      <form @submit.prevent="clickAction">
        <component
          :is="componentMap[v.$model.type]"
          v-for="v in $v.fields.$each.$iter"
          :key="v.$model.name"
          v-model="v.value.$model"
          v-bind="v.$model"
          :validate="v.value"
          :validation-trigger="v.$model.type === 'integer' ? 'change' : 'blur'"
        />
        <button type="submit" aria-hidden="true" style="display: none"></button>
      </form>
    </template>

    <ul class="chat-message__actions">
      <li
        v-for="(action, index) in widgetActions"
        :key="`action-${index}`"
        v-theme-bg-hover
        :class="checkActionState(index)"
        @click="clickAction"
      >
        {{ action.text }}
      </li>
    </ul>
  </chat-message>
</template>

<script>
import { Chat } from 'src/apis'
import ActionWidget from './ActionWidget.vue'
import { requiredIf, email, integer } from 'vuelidate/lib/validators'
import ChatInput from './ChatForm/ChatInput'
import ChatTextarea from './ChatForm/ChatTextarea'
import ChatSelect from './ChatForm/ChatSelect'
import ChatYesNo from './ChatForm/ChatYesNo'
import ChatMultiSelect from './ChatForm/ChatMultiSelect'
import ChatDatePicker from './ChatForm/ChatDatePicker'
import ChatTimePicker from './ChatForm/ChatTimePicker'
import _map from 'lodash/map'
import { useChatStore } from 'Store/chat'

const componentMap = {
  email: 'ChatInput',
  text: 'ChatInput',
  integer: 'ChatInput',
  boolean: 'ChatYesNo',
  textarea: 'ChatTextarea',
  date: 'ChatDatePicker',
  time: 'ChatTimePicker',
  multi_select: 'ChatMultiSelect',
  select: 'ChatSelect'
}

export default {
  name: 'TemplateWidget',

  components: {
    ChatInput,
    ChatTextarea,
    ChatYesNo,
    ChatSelect,
    ChatDatePicker,
    ChatTimePicker,
    ChatMultiSelect
  },
  extends: ActionWidget,

  setup() {
    const chatStore = useChatStore()

    return { chatStore }
  },

  data() {
    return {
      componentMap
    }
  },

  computed: {
    fields() {
      return this.chat.message_rich.fields || []
    },

    isCollectUserInputForm() {
      return this.chat.message_rich.type === 'collect_user_input_form'
    },

    widgetActions() {
      return this.chat.message_rich.actions || [{ text: this.$t('contact_form.submit') }]
    }
  },

  methods: {
    handleCollectUserInputFormSubmit() {
      Chat.sendMessage('', {
        customBotFormFields: this.getFormattedVariables()
      })
    },

    getFormattedVariables() {
      return this.fields.map((v) => {
        const variable = { ...v }

        if (variable.type === 'multi_select') {
          return {
            ...variable,
            value: _map(variable.value, 'name')
          }
        }

        if (variable.value === null) {
          variable.value = ''
        }

        return {
          ...variable,
          value: variable.value
        }
      })
    },

    clickAction() {
      this.$v.$touch()
      if (this.$v.$invalid || !this.active) return

      if (this.isCollectUserInputForm) {
        this.handleCollectUserInputFormSubmit()
        return
      }

      const payload = {
        auto_message_id: this.chat.message_rich.auto_message_info.auto_message_id,
        variables: this.getFormattedVariables()
      }
      Chat.sendForm(this.chatStore.chatId, payload)
        .then(() => {
          this.active = false
        })
        .catch((err) => {
          console.error('fail on sending email', err)
        })
    }
  },

  validations: {
    fields: {
      $each: {
        value: {
          required: requiredIf((variable) => variable.required),
          integer(value, item) {
            if (item.type !== 'integer') return true

            return integer(value)
          },
          email: function (value, item) {
            if (item.type !== 'email') return true
            else {
              return email(value)
            }
          }
        }
      }
    }
  }
}
</script>
